import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import BranchTicketsPerAgent from "../../../components/branches/reports/daily/BranchTicketsPerAgent";
import {
  AGENT_TICKETS_PER_SERVICE_COLUMN_DEFINITIONS,
} from "../../../store/renderConfig";

const asArray = (data) => (Array.isArray(data) ? data : [data]);

const DailyBranchTicketsPerAgent = ({
  reportIndex = "**REPORT_INDEX**",
}) => (
  <DailyGeneratedReportPage
    columnDefinitions={AGENT_TICKETS_PER_SERVICE_COLUMN_DEFINITIONS}
    descriptionKey="TicketsByAgents"
    normalizeData={asArray}
    title={`${reportIndex}. Tickets Per Agent`}
  >
    {({ data, renderConfig }) => (
      <BranchTicketsPerAgent reportIndex={reportIndex} data={data} renderConfig={renderConfig} />
    )}
  </DailyGeneratedReportPage>
);

export default DailyBranchTicketsPerAgent;
